<template>
    <div id="permission_create">
        <div :class="`loader${loaderClass}`" v-show="loading">

        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                <div class="page-name">
                    <span id="permissionHeader">Add Permission</span>
                    <button type="submit" class="btn btn-success waves-effect pull-right" v-on:click.prevent="BackPermissionList">
                            Back
                    </button>
                </div>
                <div class="admin-page-content">
                    <section class="internal-container">
                        <div class="container">
                            <form autocomplete="off" class="form-horizontal" id="PermissionForm">

                                <div class="form-group">
                                    <label class="control-label col-sm-2" for="name">Name:</label>
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Permission Name" name="name">
                                        <div class="c-error">{{name_error_msg}}</div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="control-label col-sm-2" for="module">Module Name :</label>
                                    <div class="col-sm-6">
                                        <v-select v-model="selectedModule" name="selectedModule" placeholder="Select Module"
                                                label="text" class="custom-vselect"
                                                :options="modulesArr" id="module">
                                        </v-select><br/><br/>
                                        <div class="c-error">{{module_msg}}</div>

                                        <!-- <div class="c-error">
                                            {{module_msg}}
                                        </div>

                                        <div v-if="moduleeerrors.length">
                                            <template v-for="moduleeerror in moduleeerrors" v-bind:class="msgClass">
                                                <div :key="moduleeerror.id" class="c-error">
                                                    {{ moduleeerror }}
                                                </div>
                                            </template>
                                        </div> -->
                                    </div>
                                </div>


                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-offset-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>

                                <!-- <div class="form-group"> -->
                                <div class="col-sm-offset-5 col-sm-6">
                                    <input type="submit" id="cancelPermissionBtn" value="Cancel" class="btn btn-primary nextBtn btn-lg pull-right" v-on:click.prevent="BackPermissionList">
                                    <input type="submit" id="createAndContinuePermissionBtn" value="Save and Continue" class="btn btn-primary nextBtn btn-lg pull-right" v-on:click.prevent="CreatePermission(flag='Save and Continue')">
                                    <input type="submit" id="createPermissionBtn" value="Save" class="btn btn-primary nextBtn btn-lg pull-right" v-on:click.prevent="CreatePermission">
                                </div>
                                <!-- </div> -->

                            </form>
                        </div>
                    </section>
                </div>
            </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
  name: "PermissionCreate",

  mixins:[commonMixins],
  data: () => ({
     permissions: [],
    cantAccessPage: "",
    name: "",
    selectedModule: "",
    modulesArr:[],
    moduleeerrors:[],
    module_msg:"",
    loading:false,
    name_error_msg: ""
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_permission' || permissions[i].name == 'update_permission') {
                        self.cantAccessPage = true;

                        setTimeout(function () {
                            var path = window.location.pathname;
                            var segments = path.split("/");

                            if (segments[3]) {
                                $("#createPermissionBtn").val("Update");
                                $("#permissionHeader").text("Edit Permission");
                                $("#createAndContinuePermissionBtn").hide();
                                self.loadPermission();
                            }
                        }, 100);
                    }
                }
            }

        }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.getModuleNames();
  },
  methods: {

    BackPermissionList() {
      var self = this;
      self.$router.push("/permissions/list");
    },

    CreatePermission(flag) {

      var self = this;

      self.name_error_msg = "";
      self.module_msg = "";

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Name Required.";
      }

      if (self.selectedModule == null || !self.selectedModule.value) {
        self.module_msg = "Module Name Required.";
      }

      if (self.name_error_msg == "" && self.module_msg == "") {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createPermissionBtn").val("Updating ...");
                $("#createPermissionBtn").prop("disabled", true);
                $("#cancelPermissionBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinuePermissionBtn").val("Saving ...");
                    $("#createPermissionBtn").prop("disabled", true);
                    $("#createAndContinuePermissionBtn").prop("disabled", true);
                    $("#cancelPermissionBtn").prop("disabled",true);

                }else{

                    $("#createPermissionBtn").val("Saving ...");
                    $("#createPermissionBtn").prop("disabled", true);
                    $("#createAndContinuePermissionBtn").prop("disabled", true);
                    $("#cancelPermissionBtn").prop("disabled",true);
                }

            }

            $.ajax({
                url: process.env.ROOT_API + "/permission/create",
                type: "POST",
                data: { module_id: self.selectedModule.value, name: self.name, id: segments[3]},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createPermissionBtn").val("Update");
                        $("#createPermissionBtn").prop("disabled", false);
                        $("#cancelPermissionBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinuePermissionBtn").val("Save and Continue");
                            $("#createPermissionBtn").prop("disabled", false);
                            $("#createAndContinuePermissionBtn").prop("disabled", false);
                            $("#cancelPermissionBtn").prop("disabled",false);

                        }else{

                            $("#createPermissionBtn").val("Save");
                            $("#createPermissionBtn").prop("disabled", false);
                            $("#createAndContinuePermissionBtn").prop("disabled", false);
                            $("#cancelPermissionBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            self.name = "";
                            self.selectedModule = "";
                            $("#PermissionForm").trigger("reset");

                        }else{
                            self.$router.push("/permissions/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createPermissionBtn").val("Update");
                        $("#createPermissionBtn").prop("disabled", false);
                        $("#cancelPermissionBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            self.name = "";
                            self.selectedModule = "";
                            $("#PermissionForm").trigger("reset");

                            $("#createAndContinuePermissionBtn").val("Save and Continue");
                            $("#createPermissionBtn").prop("disabled", false);
                            $("#createAndContinuePermissionBtn").prop("disabled", false);
                            $("#cancelPermissionBtn").prop("disabled",false);

                        }else{

                            $("#createPermissionBtn").val("Save");
                            $("#createPermissionBtn").prop("disabled", false);
                            $("#createAndContinuePermissionBtn").prop("disabled", false);
                            $("#cancelPermissionBtn").prop("disabled",false);

                        }
                    }
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");

                            self.$router.push("/");
                        }
                        $("#errorMsg").html(jqXHR.responseJSON.message);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);
                    }
                }
            });
      }

    },

    loadPermission() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/permission/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.name = data.content.name;
                    self.selectedModule = {value: data.content.module_id, text: data.content.module_name};
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");

                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },

    getModuleNames:function(){

        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/get-modules",
            type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            success: function (data) {
                //console.log(data.content.email);
                if (data.status == "success") {

                    self.modulesArr = data.content;
                }

            },
            error: function (jqXHR, exception) {
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");

                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });

    }

  }
};
</script>



// WEBPACK FOOTER //
// src/components/PermissionCreate.vue